<div fxFlex="32px"  fxLayoutAlign="center center">
    <kendo-icon  *ngIf="externalUrl" class="pointer" [name]="'redo'" (click)="navigateToUrl()"></kendo-icon>
  </div>
